/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
const _ = require('underscore')

let has3dTrans

module.exports = {
  t: 'transform',
  hasVal: undefined,
  has() {
    if (has3dTrans !== undefined) {
      return has3dTrans
    }

    const el = document.createElement('p')
    let t
    let has3d
    const transforms = {
      transform: 'transform',
      webkitTransform: '-webkit-transform',
      OTransform: '-o-transform',
      msTransform: '-ms-transform',
      MozTransform: '-moz-transform',
    }

    // Add it to the body to get the computed style
    document.body.insertBefore(el, null)

    // eslint-disable-next-line no-restricted-syntax
    for (t in transforms) {
      if (el.style[t] !== undefined) {
        this.t = t
        el.style[t] = 'translate3d(1px,1px,1px)'
        has3d = window.getComputedStyle(el).getPropertyValue(transforms[t])
        if (has3d) {
          break
        }
      }
    }

    document.body.removeChild(el)

    has3dTrans = has3d !== undefined && has3d.length > 0 && has3d !== 'none'
    return has3dTrans
  },

  mapTo(params) {
    if (this.hasVal === undefined) {
      this.hasVal = this.has()
    }

    const newParams = _.clone(params)
    newParams[this.t] = `translate3d(${params.x || 0}px, ${params.y || 0}px, 0)`

    if (newParams.scale) {
      newParams[this.t] += ` scale(${params.scale})`
    }

    delete newParams.x
    delete newParams.y
    delete newParams.scale

    return newParams
  },

  styleTo(el, params) {
    const p = this.mapTo(params)

    if (el[0]) {
      el = el[0]
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const i in p) {
      // eslint-disable-next-line no-prototype-builtins
      if (p.hasOwnProperty(i)) {
        el.style[i] = p[i]
      }
    }
  },
}
